import { render, staticRenderFns } from "./PostCourse.vue?vue&type=template&id=00ffa58e&"
import script from "./PostCourse.vue?vue&type=script&lang=js&"
export * from "./PostCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports